import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { jmd, timeLeft } from "@/lib/format";
import { Zap, Loader2 } from "lucide-react";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, force] = useState(0);
  useEffect(() => { api.get("/deals").then(({ data }) => { setDeals(data); setLoading(false); }).catch(() => {}); }, []);
  useEffect(() => { const t = setInterval(() => force((v) => v + 1), 1000); return () => clearInterval(t); }, []);

  return (
    <div>
      <section className="sn-ink-bg sn-noise text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
          <span className="inline-flex items-center gap-2 bg-coral sn-pill px-4 py-1.5 text-xs font-semibold uppercase tracking-wider"><Zap size={14} /> Deals Engine</span>
          <h1 className="font-clash font-bold text-4xl sm:text-5xl mt-4">Today's Best Deals</h1>
          <p className="text-white/70 mt-3">Only deals approved by the SHOP NOW desk on real, in-stock products go live. Sample cards show what the deals engine will look like — they are not for sale.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {loading ? <div className="grid place-items-center py-16"><Loader2 className="animate-spin text-emerald" size={32} /></div> : (
          <>
          {deals.length > 0 && deals.every((d) => d.sample) && <div className="mb-6 rounded-2xl border border-amber-200 bg-amber-50 text-amber-900 p-4 text-sm" data-testid="deals-coming-soon">Live deals are <b>coming soon</b>. The cards below are <b>sample deals</b> for illustration only — no prices, no checkout.</div>}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {deals.map((d) => {
              const tl = timeLeft(d.ends_at);
              if (d.sample) return (
                <div key={d.product.id} className="bg-card rounded-2xl border border-dashed border-border overflow-hidden opacity-90" data-testid={`deal-sample-${d.product.id}`}>
                  <div className="relative aspect-square bg-slate-100">
                    <img src={d.product.image} alt={d.product.name} className="h-full w-full object-cover grayscale-[30%]" />
                    <span className="absolute top-3 left-3 bg-ink text-white text-xs font-bold px-2.5 py-1 rounded-full">Sample deal</span>
                    <span className="absolute top-3 right-3 bg-amber-400 text-ink text-[10px] font-extrabold px-2 py-1 rounded-full uppercase">Coming soon</span>
                  </div>
                  <div className="p-4">
                    <div className="font-display font-semibold text-sm line-clamp-2 h-10">{d.product.name}</div>
                    <div className="text-xs text-muted-foreground mt-2">{d.title} · illustration only</div>
                    <div className="mt-3 text-xs bg-secondary text-muted-foreground rounded-lg px-3 py-1.5 text-center font-semibold">Not for sale</div>
                  </div>
                </div>
              );
              return (
                <Link key={d.product.id} to={`/product/${d.product.id}`} className="group bg-card rounded-2xl border border-border overflow-hidden sn-card-hover">
                  <div className="relative aspect-square bg-slate-100">
                    <img src={d.product.image} alt={d.product.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-3 left-3 bg-coral text-white text-xs font-bold px-2.5 py-1 rounded-full">{d.title}</span>
                    <span className="absolute top-3 right-3 bg-ink text-white text-xs font-bold px-2 py-1 rounded-full">-{d.product.discount}%</span>
                  </div>
                  <div className="p-4">
                    <div className="font-display font-semibold text-sm line-clamp-2 h-10">{d.product.name}</div>
                    <div className="flex items-center gap-2 mt-2"><span className="font-display font-bold text-lg">{jmd(d.product.price)}</span><span className="text-sm line-through text-muted-foreground">{jmd(d.product.prev_price)}</span></div>
                    <div className="mt-3 font-mono-sn text-sm bg-ink text-white rounded-lg px-3 py-1.5 text-center">
                      {tl.done ? "Deal Ended" : `Ends in ${String(tl.h).padStart(2, "0")}:${String(tl.m).padStart(2, "0")}:${String(tl.s).padStart(2, "0")}`}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          </>
        )}
      </div>
    </div>
  );
}
